import React from 'react';
import { DateRangeWithCustomOptionFilterSelect } from 'src/components/sidebar-filters/filter-select/DateRangeWithCustomOptionFilterSelect';

const BILL_PERIOD_OPTIONS = [
    { value: 'current_month', label: 'Current month' },
    { value: 'current_quarter', label: 'Current quarter' },
    { value: 'previous_month', label: 'Previous month' },
    { value: 'previous_quarter', label: 'Previous quarter' },
    { value: 'custom_range', label: 'Custom range' },
];

interface IBillPeriodFilterSelectProps {
    value: string | null;
    onChange: (value: string | null) => void;
    label?: string;
    height?: number;
}

export const BillPeriodFilterSelect: React.FC<IBillPeriodFilterSelectProps> = ({ value, onChange, label = 'Billing period', height = 180 }) => {
    return (
        <DateRangeWithCustomOptionFilterSelect
            height={height}
            label={label}
            value={value}
            onChange={onChange}
            options={BILL_PERIOD_OPTIONS}
            dateFormat="DD/MMM/YYYY"
            pickerMode="date"
        />
    );
};
